import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart } from '@fortawesome/free-solid-svg-icons/faHeart';
import { useLocation } from 'react-router-dom';
export default function CommonElements({ data, onThankYouClick, headerSubtitle = data.header_subtitle, giveLink }) {
    const initialItem = React.useRef(null);
    const { pathname } = useLocation();
    React.useEffect(() => { var _a; return (_a = initialItem.current) === null || _a === void 0 ? void 0 : _a.focus(); }, []);
    return (React.createElement(React.Fragment, null,
        pathname.startsWith('/k12') ? (React.createElement("img", { className: "k12-header-image", src: '/dist/images/k12/download-resource.jpg', alt: "", width: "240" })) : (React.createElement("img", { className: "header-image", src: data.header_image, alt: "", height: "165", width: "165" })),
        React.createElement("p", null,
            React.createElement("span", { className: "header-title" }, data.header_title),
            React.createElement("br", null),
            React.createElement("span", null, headerSubtitle)),
        React.createElement("div", { className: "button-row" },
            React.createElement("a", { href: giveLink, className: "btn primary", onClick: OpenGiveInNewWindow, "data-nudge-action": "interacted", ref: initialItem },
                data.give_link_text,
                React.createElement(FontAwesomeIcon, { icon: faHeart })),
            React.createElement("a", { href: data.thank_you_link, className: "btn secondary", onClick: onThankYouClick, "data-nudge-action": "thank-you" }, data.thank_you_link_text)),
        React.createElement("p", { className: "giving-optional" }, data.giving_optional),
        React.createElement("hr", null)));
}
function OpenGiveInNewWindow(event) {
    event.preventDefault();
    const url = event.target.href;
    const { innerWidth, innerHeight } = window;
    const w = 0.8 * innerWidth;
    const h = 0.8 * innerHeight;
    window.open(url, 'givewindow', `menubar=0,width=${w},height=${h}`);
}
